import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';
import logo from "../../assets/logo.png";

const DashboardSidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [openProjects, setOpenProjects] = useState(true);

  const isActive = (path) => location.pathname === path;

  const navBtn = (path) =>
    `w-full text-left px-8 py-4 border-t border-green-300 transition-colors cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-300 ${isActive(path)
      ? 'bg-blue-500 text-white'
      : 'text-blue-600 hover:bg-blue-500 hover:text-white'
    }`;

  const subNavBtn = (path) =>
    `block w-full text-left px-8 py-3 transition-colors cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-300 ${isActive(path)
      ? 'bg-blue-500 text-white'
      : 'text-blue-500 hover:bg-blue-500 hover:text-white'
    }`;

  const handleNavClick = (path) => {
    navigate(path);
  };

  return (
    <aside className="w-72 bg-white border-r border-green-300 flex flex-col h-screen overflow-y-auto">
      {/* Logo */}
      <div className="flex items-center justify-center p-8 border-b border-green-300">
        <img
          src={logo}
          alt="HPR Logo"
          className="h-14 w-auto object-contain cursor-pointer hover:opacity-90 transition-opacity"
          onClick={() => navigate("/")}
        />
      </div>

      <nav className="flex-1 text-lg font-medium">

        {/* Footer */}
        <button
          onClick={() => handleNavClick('/dashboard/footer')}
          className={navBtn('/dashboard/footer')}
        >
          Footer
        </button>

        {/* Trustbar */}
        <button
          onClick={() => handleNavClick('/dashboard/trustbar')}
          className={navBtn('/dashboard/trustbar')}
        >
          Trustbar
        </button>

        {/* Home */}
        <button
          onClick={() => handleNavClick('/dashboard/home')}
          className={navBtn('/dashboard/home')}
        >
          Home
        </button>

        {/* About Us */}
        <button
          onClick={() => handleNavClick('/dashboard/about')}
          className={navBtn('/dashboard/about')}
        >
          About Us
        </button>

        {/* Projects Dropdown */}
        <div className="border-t border-green-300">
          <button
            onClick={() => {
              setOpenProjects(!openProjects);
              navigate("/dashboard/projects");
            }}
            className="group w-full text-left px-8 py-4 border-t border-green-300 text-blue-600 transition-colors cursor-pointer hover:bg-blue-500 hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-300 flex justify-between items-center"
          >
            <span>Projects</span>
            <ChevronDown
              size={18}
              className={`transform transition-transform ${openProjects ? "rotate-180" : ""
                } group-hover:text-white`}
            />
          </button>

          {openProjects && (
            <div className="ml-4 border-l border-green-300">
              <button
                onClick={() => handleNavClick('/dashboard/create-projects')}
                className={subNavBtn('/dashboard/create-projects')}
              >
                Create Projects
              </button>
              <button
                onClick={() => handleNavClick('/dashboard/draft-projects')}
                className={subNavBtn('/dashboard/draft-projects')}
              >
                List of Draft Projects
              </button>
              <button
                onClick={() => handleNavClick('/dashboard/ongoing-projects')}
                className={subNavBtn('/dashboard/ongoing-projects')}
              >
                Ongoing Projects
              </button>
              <button
                onClick={() => handleNavClick('/dashboard/completed-projects')}
                className={subNavBtn('/dashboard/completed-projects')}
              >
                Completed Projects
              </button>
            </div>
          )}
        </div>

        {/* Career */}
        <button
          onClick={() => handleNavClick('/dashboard/career')}
          className={navBtn('/dashboard/career')}
        >
          Career
        </button>

        {/* Blogs */}
        <button
          onClick={() => handleNavClick('/dashboard/blogs')}
          className={navBtn('/dashboard/blogs')}
        >
          Blogs
        </button>

        {/* Contact Us */}
        <button
          onClick={() => handleNavClick('/dashboard/contact-us')}
          className={navBtn('/dashboard/contact-us')}
        >
          Contact Us
        </button>
      </nav>
    </aside>
  );
};

export default DashboardSidebar;
